// TODO scaffold shopping bag to be implement in minibag User Story
import {GetBagCallbackContractModel} from "@next/eventservice"
import {ShoppingBag} from "../../models/shoppingbag"
import type State from "../state"
import {getItemImageUrl} from "../../utils/getMiniShoppingbagItemImageUrl"
import {getOrigin} from "../../utils/getOrigin"
import {excludeIncentives} from "../../utils/excludeIncentives"

export type ShoppingBagDuckState = {
    itemCount: number
    bag: ShoppingBag
    loading: boolean
    useBadge: boolean
    showMiniBagItemDescription: boolean
    showMiniBagProductName: boolean
}

export type ShoppingBagUpdateType = {
    itemCount: number
    bag: ShoppingBag
    loading: boolean
}

const initialState: ShoppingBagDuckState = {
    itemCount: 0,
    bag: {} as ShoppingBag,
    loading: true,
    useBadge: false,
    showMiniBagItemDescription: false,
    showMiniBagProductName: false,
}

export const SET_BAG = "SET_BAG"
export const SET_USE_BADGE = "SET_USE_BADGE"
export const SET_SHOW_ITEM_DESCRIPTION = "SET_SHOW_ITEM_DESCRIPTION"
export const SET_SHOW_PRODUCT_NAME = "SET_SHOW_PRODUCT_NAME"

type Actions = {
    type: typeof SET_BAG | typeof SET_USE_BADGE | typeof SET_SHOW_ITEM_DESCRIPTION | typeof SET_SHOW_PRODUCT_NAME
    payload: boolean | string | number | ShoppingBag | {itemCount: number; bag: ShoppingBag; loading: boolean}
}

const setBag = ({itemCount, bag, loading}: ShoppingBagUpdateType): Actions => ({
    type: SET_BAG,
    payload: {itemCount, bag, loading},
})

const updateUseBadge = (useBadge: boolean): Actions => ({
    type: SET_USE_BADGE,
    payload: useBadge,
})

const updateShowItemDescription = (showItemDescription: boolean): Actions => ({
    type: SET_SHOW_ITEM_DESCRIPTION,
    payload: showItemDescription,
})

const updateShowProductName = (showProductName: boolean): Actions => ({
    type: SET_SHOW_PRODUCT_NAME,
    payload: showProductName,
})

export const updateBag = (getBagData: GetBagCallbackContractModel) => (dispatch: any, getState) => {
    const {
        request: {siteUrl},

        settings: {cdnBaseUrl, threeFourImageryEnabled, miniBagImagePath},
    } = getState() as State

    if (getBagData.success) {
        const originalBag = getBagData.data.ShoppingBag
        // Create immutable copy of bag with processed items
        const bag = {
            ...originalBag,
            Items: originalBag.Items.slice()
                .reverse()
                .map(item => ({
                    ...item,
                    itemImageUrl: getItemImageUrl(item, cdnBaseUrl, threeFourImageryEnabled, miniBagImagePath),
                    Url: `${siteUrl ? getOrigin(siteUrl) : ""}${item.Url}`,
                })),
            // Create immutable copy of ChargesAndIncentives if it exists
            ChargesAndIncentives:
                originalBag.ChargesAndIncentives && originalBag.ChargesAndIncentives.length > 0
                    ? excludeIncentives(originalBag.ChargesAndIncentives)
                    : originalBag.ChargesAndIncentives,
        }
        const itemCount = getBagData.data.ShoppingBag.ItemCount
        dispatch(setBag({bag, itemCount, loading: false}))
    } else {
        const {
            bag: localBag,
            itemCount,
            loading,
            useBadge: localUseBadge,
            showMiniBagItemDescription: localItemDescription,
            showMiniBagProductName: localProductName,
        } = initialState
        dispatch(updateUseBadge(localUseBadge))
        dispatch(updateShowItemDescription(localItemDescription))
        dispatch(updateShowProductName(localProductName))
        dispatch(setBag({bag: localBag, itemCount, loading}))
    }
}

export const addEVoucherToBag = (getBagData: GetBagCallbackContractModel) => (dispatch: any, getState) => {
    const {
        shoppingBag: {bag},
        request: {siteUrl},
        settings: {cdnBaseUrl, threeFourImageryEnabled, miniBagImagePath},
    } = getState() as State
    if (getBagData.success) {
        const originalBagForEVoucher = getBagData.data.Bag != null ? getBagData.data.Bag : bag
        const {ItemCount} = originalBagForEVoucher

        // Create immutable copy of bag with processed items
        const bagForEVoucher = {
            ...originalBagForEVoucher,
            Items: originalBagForEVoucher.Items.slice()
                .reverse()
                .map(item => ({
                    ...item,
                    itemImageUrl: getItemImageUrl(item, cdnBaseUrl, threeFourImageryEnabled, miniBagImagePath),
                    Url: `${siteUrl ? getOrigin(siteUrl) : ""}${item.Url}`,
                })),
            // Create immutable copy of ChargesAndIncentives if it exists
            ChargesAndIncentives:
                originalBagForEVoucher.ChargesAndIncentives && originalBagForEVoucher.ChargesAndIncentives.length > 0
                    ? excludeIncentives(originalBagForEVoucher.ChargesAndIncentives)
                    : originalBagForEVoucher.ChargesAndIncentives,
        }
        dispatch(setBag({bag: bagForEVoucher, itemCount: ItemCount, loading: false}))
    } else {
        const {bag: localBag, itemCount, loading, useBadge: localUseBadge} = initialState
        dispatch(updateUseBadge(localUseBadge))
        dispatch(setBag({bag: localBag, itemCount, loading}))
    }
}

export const setUseBadge = (useBadge: boolean) => (dispatch: any) => {
    dispatch(updateUseBadge(useBadge))
}

export const setShowMiniBagItemDescription = (showMiniBagItemDescription: boolean) => (dispatch: any) => {
    dispatch(updateShowItemDescription(showMiniBagItemDescription))
}

export const setShowMiniShoppingBagProductName = (showMiniBagProductName: boolean) => (dispatch: any) => {
    dispatch(updateShowProductName(showMiniBagProductName))
}

const reducer = (state: ShoppingBagDuckState = initialState, action) => {
    switch (action.type) {
        case SET_BAG:
            return {...state, ...action.payload}
        case SET_USE_BADGE:
            return {...state, useBadge: action.payload}
        case SET_SHOW_ITEM_DESCRIPTION:
            return {...state, showMiniBagItemDescription: action.payload}
        case SET_SHOW_PRODUCT_NAME:
            return {...state, showMiniBagProductName: action.payload}
        default:
            return state
    }
}

export default reducer
